/**
*
*   Manifest
*       - The Manifest Slider
*
**/
'use client';


import Config from '@/config';
import Button from '@/components/button';
import Image from '@/components/image';
import { useRef, useState } from 'react';
import { useLocale, useTranslations } from 'next-intl';
import { Swiper, SwiperSlide, useSwiper } from 'swiper/react';
//import 'swiper/css';

//Build the Element
export default function Manifest( props ){

    const t      = useTranslations(),
        locale   = useLocale(),
        ref      = useRef(),
        swiper   = useRef(),
        Manifest = {

            data: [{
                image: 'icon-earth.svg',
                title: {
                    en: 'Choose Earth-Conscious Packaging',
                    fr: 'Choisir un emballage respectueux de l\'environnement'
                },
                description: {
                    en: 'Buy products packaged with 100% recyclable bottles and boxes made with natural pulp paper',
                    fr: 'Acheter des produits conditionnés avec des bouteilles 100 % recyclables et des boîtes fabriquées avec du papier à base de pâte naturelle.'
                }
            },{
                image: 'icon-reviews-no-circle.svg',
                title: {
                    en: 'Earn Points with Every Purchase',
                    fr: 'Gagnez des points à chaque achat'
                },
                description: {
                    en: 'Earn 1 petal point for every dollar spent and apply those points to new purchases',
                    fr: 'Gagnez 1 point petal pour chaque dollar dépensé et appliquez ces points à vos nouveaux achats.'
                }
            },{
                image: 'icon-certification-no-circle.svg',
                title: {
                    en: 'Batch-Tested Purity',
                    fr: 'Pureté testée par lots'
                },
                description: {
                    en: 'Embrace confidence with our batch-tested essential oils (and blends) easily searchable with 100% purity',
                    fr: 'Faites confiance à la seule entreprise canadienne qui teste chaque huile essentielle par lots pour en garantir la pureté à 100 %.'
                }
            },{
                image: 'icon-plant-a-tree.svg',
                title: {
                    en: 'Nurture New Life',
                    fr: 'Nourrir une nouvelle vie'
                },
                description: {
                    en: 'Give back to the earth with 1 tree planted for every fulfilled order',
                    fr: 'Redonnez à la terre en plantant un arbre pour chaque commande satisfaite.'
                }
            },{
                image: 'icon-delivery.svg',
                title: {
                    en: 'Fall in love with Free Shipping',
                    fr: 'Tombez amoureux de la livraison gratuite'
                },
                description: {
                    en: 'Get your order delivered to your doorstep for free with purchases of $55 or more',
                    fr: 'Faites-vous livrer gratuitement à domicile à partir d\'un achat de 55 $.'
                }
            },{
                image: 'icon-heart.svg',
                title: {
                    en: 'Be 100% Happy',
                    fr: 'Être heureux à 100'
                },
                description: {
                    en: 'Feed your curiosity and try a new scent or blend risk-free with a 30-day exchange or full refund promise',
                    fr: 'Nourrissez votre curiosité et essayez une nouvelle senteur ou un nouveau mélange sans risque, avec une promesse d\'échange ou de remboursement intégral sous 30 jours.'
                }
            },{
                image: 'icon-present-full-color.svg',
                title: {
                    en: 'Enjoy a Thoughtful Surprise',
                    fr: 'Profitez d\'une surprise bien pensée'
                },
                description: {
                    en: 'Unwrap a small gift sent with love from Fern & Petal with orders over $80.',
                    fr: 'Déballez un petit cadeau envoyé avec amour par Fern & Petal avec les commandes de plus de 80 $.'
                }
            }],

            //The Swiper Settings
            Swiper: {

                //Params
                loop: true,
                centeredSlides: true,
                slidesPerView:  5,
                spaceBetween:   10,
                autoPlay:       {
                    delay:  7000
                },
                breakpoints: {
                    '0': {
                        slidesPerView:    1,
                        spaceBetween:     10
                    },
                    '500': {
                        slidesPerView:    2,
                        spaceBetween:     40
                    },
                    '800': {
                        slidesPerView:    3,
                        spaceBetween:     10
                    },
                    '1000': {
                        slidesPerView:    'auto',
                        spaceBetween:     10
                    }
                },


                /**
                *
                *   next
                *       - Overrides default swiper to activate each slide
                *
                *   Params:
                *       n/a
                *
                **/
                onSwiper: instance => {

                    //Go to Next
                    swiper.current = instance;

                },

            },


            /**
            *
            *   next
            *       - Overrides default swiper to activate each slide
            *
            *   Params:
            *       n/a
            *
            **/
            next: e => {

                //Go to Next
                swiper.current.slideNext();

            },


            /**
            *
            *   previous
            *       - Overrides default swiper to activate each slide
            *
            *   Params:
            *       n/a
            *
            **/
            previous: e => {

                //Go to previous slide
                swiper.current.slidePrev();

            }
        }

    //Return
    return (
        <section id="manifest" className="container" ref={ ref }>
            <header>
                <h2>Manifest how <em>you want to feel</em></h2>
            </header>
            <div className="slider">
                <Swiper {...Manifest.Swiper} className="list">{
                    Manifest.data.map( ( row , i ) => {
                        return (
                            <SwiperSlide key={ i }>
                                <div>
                                    <div className="icon">
                                        <Image src={ 'icons/' + row.image } alt="" width="50" height="50" />
                                    </div>
                                    <h3>{ row.title[ locale ] }</h3>
                                    <p>{ row.description[ locale ] }</p>
                                </div>
                            </SwiperSlide>
                        );
                    })
                }</Swiper>
                <nav>
                    <Button onClick={ () => Manifest.previous() }>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="19" viewBox="0 0 20 19" fill="none">
                            <path d="M10.6317 1.81006L18.4803 9.65863L10.6317 17.5072" stroke="white" strokeWidth="1.85526" strokeLinecap="round" strokeLinejoin="round"/>
                            <path d="M18.4802 9.65869L1.78296 9.65869" stroke="white" strokeWidth="1.85526" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </Button>
                    <Button onClick={ () => Manifest.next() }>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="19" viewBox="0 0 20 19" fill="none">
                            <path d="M10.6317 1.81006L18.4803 9.65863L10.6317 17.5072" stroke="white" strokeWidth="1.85526" strokeLinecap="round" strokeLinejoin="round"/>
                            <path d="M18.4802 9.65869L1.78296 9.65869" stroke="white" strokeWidth="1.85526" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </Button>
                </nav>
            </div>
        </section>
    );

}